import { useDispatch } from "react-redux";
import Xarrow from "react-xarrows";
import { importFromYaml } from "../../../../abstract/controller/modelYamlImport";
import * as tutorialUtils from "../../../../abstract/controller/utils/tutorialUtils";
import { useArrowSync } from "../../../../abstract/hook/useArrowSync";
import { setRoot } from "../../../../abstract/redux/slice/structureSlice";
import ButtonIntroWide from "../../../ui/buttons/ButtonIntroWide";
import ButtonTomatoClose from "../../../ui/buttons/ButtonTomatoClose";
import styles from "./Manual.module.scss";

const id = "dNT2";
const idNext = "dNT3";
const idPrev = "dNT1";

const next = `
functions:
  - function: Demo
    parameters:
      - parameter: Exclusion_Service
`;

const prev = `
functions:
  - function: Default
`;

function ManualDedicatedNorskTipping2({ tutorial, setTutorial }) {
  if (tutorial === id) {
    return <Core setTutorial={setTutorial} />;
  }

  return null;
}

function Core({ setTutorial }) {
  const _dispatch = useDispatch();
  const renderTrigger = useArrowSync();

  const handleShowMe = () => {
    const { model } = importFromYaml(next);
    _dispatch(setRoot(model, 0));
  };

  const handleBack = () => {
    const { model } = importFromYaml(prev);
    _dispatch(setRoot(model, 0));
    setTutorial(idPrev);
  };

  const handleClose = () => {
    setTutorial("null");
  };

  return (
    <>
      {document.getElementById("add_input_parameter") && (
        <div className={`${styles["container"]} ${styles["container-dnt2"]} ${styles["overlay"]}`}>
          <div id="tutorial-text-2" className={`${styles["container__text"]}`}>
            <p>
              Click here to add your first parameter and name it <b>Exclusion_Service</b>.
            </p>
          </div>

          <Xarrow
            key={`arrow-3-${renderTrigger}`}
            start="tutorial-text-2"
            end="add_input_parameter"
            color="#415B32"
            strokeWidth={2}
            path="smooth"
            curveness={0.8}
            headSize={6}
          />
        </div>
      )}

      <div className={`${styles["foreground"]} ${styles["foreground-dnt2"]} ${styles["overlay"]}`}>
        <ButtonTomatoClose onClick={handleClose} />

        <div className={styles["header"]}>
          <div className={styles["header__assistant"]}></div>
          <div className={styles["header__text--main"]}>
            <p>
              As you may have noticed there is a small red mark beside the function name, this is a
              global way in Tomato for signifying that there is an error, in our case the error is
              that the function does not have any parameters yet.
            </p>
            <p>
              After clicking on a button labeled <b>Add Parameter</b>, you’ll be prompted to add a
              name, let’s go ahead and enter <b>Exclusion_Service</b>. This will instantiate an
              empty parameter, which will have a red mark since it does not have any choices.
            </p>
          </div>
        </div>
        <div className={styles["confirmation"]}>
          <div className={styles["button"]}>
            <ButtonIntroWide theme="red" title="Go back!" onClick={handleBack} />
          </div>
          <div className={styles["button"]}>
            <ButtonIntroWide theme="tomato" title="Show me!" onClick={handleShowMe} />
          </div>
        </div>
      </div>
    </>
  );
}

export const manualValidateDedicatedNorskTipping2 = (root, tutorial, setTutorial, setMessage) => {
  if (tutorial === id) {
    let { res: resFun, msg: msgFun } = tutorialUtils.validateSingleFunction(root);

    if (!resFun) {
      setMessage(msgFun)
      return false;
    }

    let { res: resParam, msg: msgParam } = tutorialUtils.validateParameters(root, false, false, [
      "Exclusion_Service",
    ]);

    if (!resParam) {
      setMessage(msgParam)
      return false;
    }

    setTutorial(idNext);

    setMessage("")
    return true;
  }

  return false;
};

export default ManualDedicatedNorskTipping2;
